module.exports = __webpack_public_path__ + "img/sloat-hanebaro.b4a5cc15.jpg";